import {Toolbar} from "@fluentui/react-components";
import styled from "styled-components";
import {Breakpoints} from "./breakpoints";

export const CollapsibleToolbar = styled(Toolbar)`
    @media (max-width: ${Breakpoints.md}) {
        display: block;
    }
`